import React, { Component } from 'react';
import './index.less';
import Maxsalenum from './maxsalenum';

/**
 * 设置用户最大兑换量
 */
export class MaxSaleNum extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                <Maxsalenum rows={row} entity={entity} />
            </div>
        );
    }
}
